<ng-container>
  <div
    class="c01-tv-frame {{ customClass }}"
    [ngStyle]="frameStyles"
    [ngClass]="{ 'crop-bottom': isHisenseBrand }"
  >
    <div class="tv-frame-content">
      <ng-content></ng-content>
      <div *ngIf="hasBlackOverlay" data-animation="tv-frame-screen" class="tv-frame-overlay"></div>
    </div>
  </div>

  <picture *ngIf="isHisenseBrand">
    <source srcset="{{ '/assets/images/hisense-tv-frame.webp' | assetpipe }}" type="image/webp" />
    <source srcset="{{ '/assets/images/hisense-tv-frame.png' | assetpipe }}" type="image/jpeg" />
    <img
      width="1920"
      height="1080"
      alt=""
      class="hisense-tv-frame  {{ customClass }}"
      src="{{ '/assets/images/hisense-tv-frame.png' | assetpipe }}"
    />
  </picture>
</ng-container>
